jQuery(document).ready(showInit);

function showInit(){
	
	setupBuyNow();
	
}

function setupBuyNow() {
	
	var spektrixIDSelected = false;
	
	jQuery(".right iframe").on("load", function(){
		jQuery(this).parents(".remodal").removeClass("iframe-loading");
	});
	
	jQuery("a.performance-buy-now").on("click", function(){
		
		var current = jQuery(this);
		var inModal = !current.attr("data-remodal-target");
		
		if(current.hasClass("active")) {
			return false;
		}
		
		var spektrixID = current.attr("data-spektrix-id");
		var parent = current.parents(".remodal");
		var iFrame = jQuery(".right iframe", parent);
		
		parent.addClass("iframe-loading");
		iFrame.attr("src", "https://tickets.rosetheater.org/rosetheater/website/ChooseSeats.aspx?WebInstanceId=" + spektrixID);
		
		if(inModal) {
		
			jQuery("a.active", parent).removeClass("active");
			parent.removeClass("show-not-selected");
			current.addClass("active");
			
			spektrixIDSelected = false;
			
		} else {
			
			spektrixIDSelected = current.attr("data-spektrix-id");
			
		}
		
	});
	
	jQuery(document).on('opened', '.remodal', function(){
		
		var modal = jQuery("div.remodal.remodal-is-opened");
		
		if(spektrixIDSelected) {
			jQuery(".left li a[data-spektrix-id='" + spektrixIDSelected + "']", modal).trigger("click");
		}
		
	});
	
}
